// animations.js — StateDecal
// Scroll reveal (IntersectionObserver) + hero parallax

(function () {

  // Mark JS as available — CSS uses .js selector to hide elements before reveal
  document.documentElement.classList.add('js');

  // ── Scroll Reveal ──────────────────────────────────────────────────────────
  var REVEAL_SELECTORS = [
    '.product-card',
    '.featured-collection__heading',
    '.featured-collection__view-all',
    '.newsletter__copy',
    '.newsletter__form-wrap',
    '.footer-benefits__item',
    '.hero-banner__content > *',
    '.collection-header__title',
    '.collection-header__description',
    '.collection-header__count',
    '.homepage-stats__item',
    '[data-reveal]'
  ].join(',');

  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('js-revealed');
      revealObserver.unobserve(entry.target);
    });
  }, {
    threshold: 0.08,
    rootMargin: '0px 0px -48px 0px'
  });

  function initReveal() {
    var elements = document.querySelectorAll(REVEAL_SELECTORS);

    elements.forEach(function (el) {
      // Stagger product cards within each grid row
      if (el.classList.contains('product-card')) {
        var siblings = Array.from(el.parentElement.querySelectorAll('.product-card'));
        var idx = siblings.indexOf(el) % 4; // max 4 columns
        el.style.transitionDelay = (idx * 90) + 'ms';
      }

      // Stagger hero content children (eyebrow → heading → subheading → CTA)
      if (el.closest('.hero-banner__content')) {
        var heroChildren = Array.from(el.parentElement.children);
        var hIdx = heroChildren.indexOf(el);
        el.style.transitionDelay = (hIdx * 120) + 'ms';
      }

      // Stagger footer benefits items
      if (el.classList.contains('footer-benefits__item')) {
        var benefitSiblings = Array.from(el.parentElement.querySelectorAll('.footer-benefits__item'));
        var bIdx = benefitSiblings.indexOf(el);
        el.style.transitionDelay = (bIdx * 75) + 'ms';
      }

      // Stagger collection header children
      if (el.closest('.collection-header__inner')) {
        var chChildren = Array.from(el.closest('.collection-header__inner').children);
        var chIdx = chChildren.indexOf(el);
        el.style.transitionDelay = (chIdx * 80) + 'ms';
      }

      // Stagger homepage stats items
      if (el.classList.contains('homepage-stats__item')) {
        var statSiblings = Array.from(el.parentElement.querySelectorAll('.homepage-stats__item'));
        var sIdx = statSiblings.indexOf(el);
        el.style.transitionDelay = (sIdx * 110) + 'ms';
      }

      revealObserver.observe(el);
    });
  }

  // ── Hero Parallax ──────────────────────────────────────────────────────────
  function initParallax() {
    var heroImg = document.querySelector('.hero-banner__img');
    var heroContent = document.querySelector('.hero-banner__content');
    var heroBgText = document.querySelector('.hero-banner__bg-text');

    if (!heroImg && !heroContent) return;

    // Only run on desktop — parallax on mobile often feels janky
    var mq = window.matchMedia('(min-width: 768px) and (prefers-reduced-motion: no-preference)');
    if (!mq.matches) return;

    var hero = (heroImg || heroContent).closest('.hero-banner');
    var heroHeight = hero ? hero.offsetHeight : window.innerHeight;

    window.addEventListener('scroll', function () {
      var scrolled = window.scrollY;
      if (scrolled > heroHeight) return; // stop computing once hero is off screen

      // Background image drifts down (creates depth)
      if (heroImg) {
        heroImg.style.transform = 'translateY(' + (scrolled * 0.28) + 'px)';
      }

      // Content drifts up slightly (pulls away from viewer)
      if (heroContent) {
        heroContent.style.transform = 'translateY(' + (scrolled * -0.12) + 'px)';
      }

      // Giant background text drifts at a third rate (middle layer)
      if (heroBgText) {
        // Preserve the translateX(-50%) centering + add Y drift
        heroBgText.style.transform = 'translateX(-50%) translateY(' + (scrolled * 0.10) + 'px)';
      }
    }, { passive: true });
  }

  // ── Button press feedback ──────────────────────────────────────────────────
  function initButtonFeedback() {
    document.addEventListener('mousedown', function (e) {
      var btn = e.target.closest('.btn');
      if (btn) btn.classList.add('btn--pressing');
    });
    document.addEventListener('mouseup', function () {
      document.querySelectorAll('.btn--pressing').forEach(function (btn) {
        btn.classList.remove('btn--pressing');
      });
    });
  }

  // ── Init ───────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveal();
      initParallax();
      initButtonFeedback();
    });
  } else {
    initReveal();
    initParallax();
    initButtonFeedback();
  }

})();
